import { render, staticRenderFns } from "./logistic.vue?vue&type=template&id=67f08a15"
import script from "./logistic.vue?vue&type=script&lang=js"
export * from "./logistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports